var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    stroke: "#fff",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .arrow-right-icon-a{fill:#fff;opacity:0;}.arrow-right-icon-b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-528 -773)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "arrow-right-icon-a",
    width: 16,
    height: 16,
    transform: "translate(544 789) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-icon-b",
    d: "M1935.5,2276l-6.807,6.088,6.807,6",
    transform: "translate(2468.198 3062.95) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.7ef77fade4d6d41782dfa7e2e70ac0c0.svg";
export { ForwardRef as ReactComponent };